import { QRCodeSVG } from "qrcode.react";

const TwoFactorQrCode = ({ provisioningUri }) => (
  <div className="inline-flex rounded-lg border border-zinc-200 bg-white p-3">
    <QRCodeSVG
      value={provisioningUri}
      size={192}
      level="M"
      title="Authenticator setup QR code"
    />
  </div>
);

export default TwoFactorQrCode;
